export default __webpack_public_path__ + "static/media/kindLeiter.5f9c3271.png";